import * as endpoints from "./endpoints";
import * as models from "./models";
import debounce, {DebouncedFunc} from "../../scripts/debounce";

const NO_CHANGE = "no_change";

type DebouncedAppLead = (application: models.Application) => Promise<string>;

function isFieldChangeInfo(item: models.FieldChangeInfo | null): item is models.FieldChangeInfo {
    return item !== null;
}

function getModifiedFieldsArr(
    prevApp: models.Application,
    curApp: models.Application,
): models.FieldChangeInfo[] {
    const now = new Date().toISOString();

    const appFields: Array<models.FieldChangeInfo | null> = Object.values(models.AppKeys).map(
        (key) => {
            if (key === models.AppKeys.Address) {
                return null;
            }

            const prevValue = prevApp[key];
            const currentValue = curApp[key];
            if (currentValue === null || prevValue === currentValue) {
                return null;
            }

            return {
                field: key,
                value: currentValue,
                timestamp: now,
            };
        },
    );
    const filterdAppFields = appFields.filter(isFieldChangeInfo);

    const addressFields: Array<models.FieldChangeInfo | null> = Object.values(
        models.AddressKeys,
    ).map((key) => {
        const prevValue = prevApp[models.AppKeys.Address][key];
        const currentValue = curApp[models.AppKeys.Address][key];
        if (currentValue === null || prevValue === currentValue) {
            return null;
        }

        return {
            field: key,
            value: currentValue,
            timestamp: now,
        };
    });
    const filterdAddressFields = addressFields.filter(isFieldChangeInfo);

    return [...filterdAppFields, ...filterdAddressFields];
}

export default function createDebouncedAppLead(
    empty: models.Application,
    invitationCode: string | null,
    url: string,
    wait = 600,
): DebouncedFunc<DebouncedAppLead> {
    let lastLeadsApp: models.Application = empty;
    const statefulApplicationLead = (application: models.Application) => {
        const fields = getModifiedFieldsArr(lastLeadsApp, application);
        lastLeadsApp = application;
        return fields.length
            ? endpoints.applicationLead(fields, invitationCode, url)
            : Promise.resolve(NO_CHANGE);
    };
    return debounce(statefulApplicationLead, wait);
}
